// extracted by mini-css-extract-plugin
export default {"container":"Property_container__HXe5P","row":"Property_row__91j7h","fullWidth":"Property_fullWidth__s+h33"};